// extracted by mini-css-extract-plugin
module.exports = {"right-time":"campaign__right-time","time-wrapper":"campaign__time-wrapper","time-ico":"campaign__time-ico","right-path":"campaign__right-path","left-time":"campaign__left-time"};